





















import { ANY_PERIOD } from "@model/Filters";
import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";

interface TimeSeriesFrequency {
  id: number;
  name: string;
}


@Component({
  components: {},
})
export default class TimeSeriesPeriodsSelect extends Vue {
  @Prop({ default: false, type: Boolean }) allowAny!: boolean;
  @Model("change", { default: null }) value!: TimeSeriesFrequency | number | null;

  // TODO: fix. Specify types
  options: TimeSeriesFrequency[] = [];
  isLoading = false;

  get controlValue(): TimeSeriesFrequency | null {
    if (!this.value) {
      return this.allowAny ? ANY_PERIOD : null;
    }

    return typeof this.value === "number"
      ? this.options.find((x) => x.id === this.value) ?? null
      : this.value;
  }


  @Watch("$store.state.filters", { deep: true })
  updateData() {
    this.isLoading = this.$store.state.filters.isLoading;
    const result = [...this.$store.state.filters.periods];

    if (this.allowAny) {
      result.unshift(ANY_PERIOD);
    }

    this.options = result;
  }

  updateSelected(option: TimeSeriesFrequency) {
    this.$emit("change", option.id);
  }

  created() {
    this.updateData();
  }
}
